import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { IpgService } from "../../services/IpgService";
import { ExercicioService } from "../../services/ExercicioService";

export default {
  name: "GerenciarIpgs",
  components: {
    Breadcrumb,
    ActionButtons,
    StandardPagination
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Página Inicial",
        disabled: false,
        href: "/"
      },
      {
        text: "Gerenciamento de IPGs",
        disabled: true,
        href: "/gerenciar-ipgs"
      }
    ],
    // Controle de responsividade
    isMobile: false,
    isTablet: false,
    windowWidth: 0,
    items: [],
    itemSelected: [],
    page: 1,
    itemsPerPage: 10,
    totalItems: 0,
    loading: false,
    showFilters: true,
    filters: {
      exercicioFilter: null,
      codigoIpgFilter: '',
      descricaoIpgFilter: '',
      statusFilter: null
    },
    exerciciosOptions: [],
    statusOptions: [
      { text: 'Ativo', value: true },
      { text: 'Inativo', value: false }
    ],
    // Headers base da tabela
    baseHeaders: [
      {
        text: '',
        value: 'data-table-select',
        sortable: false,
        width: '50px',
        align: 'center',
        priority: 1
      },
      {
        text: 'Exercício',
        value: 'exercicio.ano',
        sortable: true,
        align: 'center',
        width: '120px',
        priority: 2
      },
      {
        text: 'Código IPG',
        value: 'codigo_ipg',
        sortable: true,
        align: 'center',
 
        priority: 1
      },
      {
        text: 'Descrição',
        value: 'descricao',
        sortable: true,
        align: 'center',
        priority: 1
      },
      {
        text: 'Status',
        value: 'ativo',
        sortable: true,
        align: 'center',
        priority: 2
      }
    ]
  }),
  computed: {
    isAllSelected() {
      return this.items.length > 0 && this.itemSelected.length === this.items.length;
    },
    isIndeterminate() {
      return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
    },
    // Headers computados - sempre mostra todas as colunas
    computedHeaders() {
      // Sempre retorna todas as colunas, independente da resolução
      // O scroll horizontal cuidará da navegação em telas pequenas
      return this.baseHeaders;
    }
  },
  async created() {
    await this.loadExercicios();
    await this.listarIpgsPaginado();
    this.handleResize();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    page: async function(newValue) {
      this.page = newValue;
      await this.listarIpgsPaginado();
    },
    'filters.codigoIpgFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarIpgsPaginado();
      }
    },
    'filters.descricaoIpgFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarIpgsPaginado();
      }
    },
    'filters.exercicioFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarIpgsPaginado();
      }
    },
    'filters.statusFilter': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarIpgsPaginado();
      }
    }
  },
  methods: {
    async loadExercicios() {
      try {
        const response = await ExercicioService.select();
        if (response && response.data) {
          this.exerciciosOptions = response.data.map(ex => ({
            text: ex.ano || ex.exercicio,
            value: ex.ano || ex.exercicio
          }));
        }
      } catch (error) {
        console.error('Erro ao carregar exercícios:', error);
        // Em caso de erro, usar opções padrão
        this.exerciciosOptions = [
          { text: '2024', value: '2024' },
          { text: '2023', value: '2023' },
          { text: '2022', value: '2022' }
        ];
      }
    },

    async listarIpgsPaginado() {
      try {
        const filter = this.prepareFormFilter();

        const response = await IpgService.index(filter);

        if (typeof response !== 'string') {
          this.items = response.data.data;
          this.totalItems = response.data.total;
          this.itemSelected = [];
          this.$forceUpdate();
        } else {
          console.error('Não foi possível obter os ipgs.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao listar os ipgs:', error);
      }
    },

    toggleFilters() {
      this.showFilters = !this.showFilters;
    },

    getRowClass(item) {
      return item.ativo ? 'row-active' : 'row-inactive';
    },

    handlePageChanged(page) {
      this.page = page;
      this.listarIpgsPaginado();
    },

    handleItemsPerPageChanged(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.page = 1;
      this.listarIpgsPaginado();
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.itemSelected = [];
      } else {
        this.itemSelected = [...this.items];
      }
    },

    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    // Navegação
    navigateToCreate() {
      this.$router.push('/ipgs/criar');
    },

    navigateToEdit() {
      if (this.itemSelected.length === 1) {
        this.$router.push(`/ipgs/editar/${this.itemSelected[0].id}`);
      }
    },

    handleExport() {
      this.$globalAlert('Funcionalidade de exportação não implementada!', 'info');
    },

    // Ações em massa
    async activateIpgs() {
      try {
        const ids = this.itemSelected.map(ipg => ipg.id);

        const formData = new FormData();

        ids.forEach(id => {
          formData.append("ipgs[]", id);
        });

        const response = await IpgService.activate(formData);

        if (!response) {
          console.error('Não foi possível ativar os ipgs.');
        }

        this.listarIpgsPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao ativar os ipgs:', error);
      }
    },

    async deactivateIpgs() {
      try {
        const ids = this.itemSelected.map(ipg => ipg.id);

        const formData = new FormData();

        ids.forEach(id => {
          formData.append("ipgs[]", id);
        });

        const response = await IpgService.deactivate(formData);

        if (!response) {
          console.error('Não foi possível desativar os ipgs.');
        }

        this.listarIpgsPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao desativar os ipgs:', error);
      }
    },

    async destroyIpgs() {
      try {
        const ids = this.itemSelected.map(ipg => ipg.id);

        const formData = new FormData();

        ids.forEach(id => {
          formData.append("ipgs[]", id);
        });

        const response = await IpgService.destroy(formData);

        if (!response) {
          console.error('Não foi possível excluir os ipgs.');
        }

        this.listarIpgsPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao excluir os ipgs:', error);
      }
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      filter.append("per_page", this.itemsPerPage);

      this.filters.codigoIpgFilter
        ? filter.append(
            "codigo",
            this.filters.codigoIpgFilter
          )
        : null;

      this.filters.descricaoIpgFilter
        ? filter.append(
            "descricao",
            this.filters.descricaoIpgFilter
          )
        : null;

      this.filters.exercicioFilter
        ? filter.append(
            "exercicio",
            this.filters.exercicioFilter
          )
        : null;

      this.filters.statusFilter !== null
        ? filter.append(
            "ativo",
            this.filters.statusFilter
          )
        : null;

      return filter;
    },
    
    // Método para detectar mudanças no tamanho da tela
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.isMobile = this.windowWidth < 768;
      this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
    }
  }
};